import React from 'react';
import { MessageCircle, Mail, Phone, Trash2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const QuestionsPanel = ({ questions, setQuestions, showNotification }) => {
  const handleDelete = async (q) => {
    if (!window.confirm('Delete this question?')) return;
    try {
      await fetch(`${API}/api/questions/${q.id}`, { method: 'DELETE' });
      setQuestions(prev => prev.filter(x => x.id !== q.id));
      showNotification('Question deleted');
    } catch (error) {
      showNotification('Failed to delete', 'error');
    }
  };

  return (
    <div className="flex-1 p-4 md:p-6 overflow-auto">
      <div className="max-w-4xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-slate-800">Have Questions</h2>
            <p className="text-sm text-slate-500">{questions.length} submissions</p>
          </div>
        </div>
        {questions.length === 0 ? (
          <div className="text-center py-12 text-slate-400">
            <MessageCircle className="w-12 h-12 mx-auto mb-3 opacity-50" />
            <p>No questions yet</p>
          </div>
        ) : (
          <div className="space-y-4">
            {questions.map((q) => (
              <div key={q.id} className="bg-white rounded-xl border border-slate-200 p-5 hover:shadow-md transition-shadow">
                <div className="flex justify-between items-start mb-3">
                  <div>
                    <span className="font-semibold text-slate-800">{q.name || 'Anonymous'}</span>
                    <span className={`ml-2 text-xs px-2 py-0.5 rounded-full ${q.status === 'new' ? 'bg-orange-100 text-orange-700' : 'bg-green-100 text-green-700'}`}>
                      {q.status}
                    </span>
                  </div>
                  <button
                    onClick={() => handleDelete(q)}
                    className="text-slate-400 hover:text-red-500 text-sm"
                    data-testid={`delete-question-${q.id}`}
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
                <p className="text-slate-700 mb-3">{q.message}</p>
                <div className="flex flex-wrap gap-4 text-sm text-slate-500">
                  {q.email && <span className="flex items-center gap-1"><Mail className="w-3.5 h-3.5" /> {q.email}</span>}
                  {q.phone && <span className="flex items-center gap-1"><Phone className="w-3.5 h-3.5" /> {q.phone}</span>}
                  <span>{new Date(q.submitted_at).toLocaleDateString()}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default QuestionsPanel;
